import React from "react";

const VoucherForDisplay = ({ item }) => {
    if (!item) return <>-</>;

    let type = "";
    let name = "";

    switch (item.expense_for || item.demand_for) {
        case "asset":
            type = "Asset : ";
            name = item.asset_profile
                ? `${item.asset_profile.name} (${item.asset_profile.asset_code})`
                : "-";
            break;

        case "workstation":
            type = "Workstation : ";
            name = item.workstation?.workstation_name || "-";
            break;

        case "sub_assembly":
            type = "Sub Assembly : ";
            name = item.sub_assembly?.name || "-";
            break;

        case "employee":
            type = "Employee : ";
            name = item.employee?.display_full_name || "-";
            break;

        case "vendor":
            type = "Vendor : ";
            name = item.vendor?.name || "-";
            break;

        case "customer":
            type = "Customer : ";
            name = item.customer?.name || "-";
            break;
        case "site":
            type = "Site : ";
            name = item.site?.site_name || "-";
            break;

        default:
            return <>-</>;
    }

    return (
        <div>
            <small className="text-muted">{type}</small>
            <span>{name}</span>
        </div>
    );
};

export default VoucherForDisplay;